import { gql } from '@apollo/client';

export const FETCH_REPORT_SCHEDULE_EXECUTION_LOGS = gql`
    query fetchReportScheduleExecutionLogs(
        $reportDefinitionId: Guid!
        $reportScheduleFilter: ReportDefinitionScheduleFilter!
    ) {
        facility {
            id
            reportDefinition(id: $reportDefinitionId) {
                schedules(filter: $reportScheduleFilter) {
                    id
                    executionLogs {
                        id
                        outcome
                        utcStartTime
                        utcEndTime
                        attempt
                        correlationId
                    }
                }
            }
        }
    }
`;
